<script setup lang="ts">
import VoucherQuickAdd from '@/components/contents/voucher/VoucherQuickAdd.vue';
import { inject, computed } from 'vue';

interface VoucherQuickAddBlok {
    _uid: string;
    component: string;
}

defineProps<{ blok: VoucherQuickAddBlok }>();

const voucherPrefill = inject<{
    amount: number | null;
    type: 'digital' | 'physical' | null;
} | null>('voucherPrefill', null);

const defaultAmount = computed(() => voucherPrefill?.amount ?? null);
const defaultType = computed(() => voucherPrefill?.type ?? null);
</script>

<template>
    <section v-editable="blok" class="py-10 xl:py-16">
        <div class="mx-auto max-w-[1290px] px-4 md:px-6 xl:px-8">
            <VoucherQuickAdd :default-amount="defaultAmount" :default-type="defaultType" />
        </div>
    </section>
</template>
